<h5 class="{data.hideOnTerminal ? 'hideOnTerminal' : ''}">
  <slot></slot>
</h5>

<style>
  h5 {
    font-size: 1.2rem;
    line-height: 1.6;
    @media(min-width: 767px) {
      font-size: 1.375rem;
      line-height: 1.48;
    }
    @media(min-width: 992px) {
      font-size: 1.5rem;
      line-height: 1.56;
    }
  }
</style>
